import { isNilOrEmpty } from '../../value/isNilOrEmpty';
import { isNotNilOrEmpty } from '../../value/isNotNilOrEmpty';
/**
 * Checks if path is a direct property of obj
 *
 * @category Object
 * @since v1.0.0
 * @param {T} obj - The object on which to operate
 * @param {string} path - The path to look for
 * @returns {boolean}
 * @example
 * const obj = { hello: { hi: 'world' } };
 * has(obj, 'hello.hi'); //=> true
 * @docgen_example
 * const obj = { hello: { hi: 'world' } };
 * has(obj, 'hello.hi');
 */
export var has = function (obj, path) {
    if (isNilOrEmpty(obj) || isNilOrEmpty(path))
        return false;
    var keys = path.split('.');
    var current = obj;
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        if (isNotNilOrEmpty(current) && key in current) {
            current = current[key];
        }
        else {
            return false;
        }
    }
    return true;
};
